// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1lJOu","content":"LoadingAlert_content__1Pg1f"};